import useSWR, { type SWRConfiguration } from 'swr'
import type {
  PostNordDeliveryOptionsRequestFE,
  PostNordDeliveryOptionsResponseFE,
  PostNordUpdateSessionRequestFE,
  PostNordUpdateSessionResponseFE,
  PostNordValidatePostalCodeRequest,
  PostNordValidatePostalCodeResponse
} from 'ecosystem'
import fetchJson from 'api/utils/next/fetchJson'
import useSWRMutation from 'swr/mutation'

export const usePostnordValidatePostalCode = (
  payload: PostNordValidatePostalCodeRequest,
  params?: { skip?: boolean; onSuccess?: (data: PostNordValidatePostalCodeResponse) => void }
) => {
  const config: SWRConfiguration<PostNordValidatePostalCodeResponse, Error> = {
    ...(params?.onSuccess ? { onSuccess: params?.onSuccess } : {})
  }

  return useSWR<PostNordValidatePostalCodeResponse>(
    params?.skip ? null : ['/api/postnord/validate-postcode', payload],
    ([url, args]) =>
      fetchJson(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(args as PostNordValidatePostalCodeRequest)
      }),
    config
  )
}

export const usePostnordGetDeliveryOptions = (
  payload: PostNordDeliveryOptionsRequestFE,
  params?: { skip?: boolean; config?: SWRConfiguration<PostNordDeliveryOptionsResponseFE, Error> }
) => {
  return useSWR<PostNordDeliveryOptionsResponseFE>(
    params?.skip ? null : ['/api/postnord/delivery-options', payload],
    ([url, args]) =>
      fetchJson(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(args as PostNordDeliveryOptionsRequestFE)
      }),
    params?.config
  )
}

export const usePostnordUpdateSessionMutation = () => {
  return useSWRMutation<
    PostNordUpdateSessionResponseFE,
    Error,
    string,
    PostNordUpdateSessionRequestFE
  >('/api/postnord/update-session', (url, { arg }) =>
    fetchJson<PostNordUpdateSessionResponseFE>(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(arg)
    })
  )
}
